import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const links = [{
    label: 'Programe Online',
    href: 'https://stelalucutaconsulting.com/primiipasi'
  }, {
    label: 'Contact',
    href: 'https://wa.me/40744377234'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-cream/95 backdrop-blur-md shadow-card' : 'bg-transparent'}`} data-id="element-285">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8" data-id="element-286">
        <div className="flex items-center justify-between h-16 md:h-20" data-id="element-287">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2.5 shrink-0" data-id="element-288">
            <svg className="w-7 h-7 text-orange" viewBox="0 0 100 100" fill="currentColor" data-id="element-289">
              <path d="M50 0C50 0 20 30 20 60C20 76.5685 33.4315 90 50 90C66.5685 90 80 76.5685 80 60C80 30 50 0 50 0ZM50 75C41.7157 75 35 68.2843 35 60C35 45 50 25 50 25C50 25 65 45 65 60C65 68.2843 58.2843 75 50 75Z" data-id="element-290" />
            </svg>
            <span className="font-fraunces font-semibold text-lg text-plum" data-id="element-291">
              Stela Lucuța
            </span>
          </a>

          {/* Desktop Links */}
          <div className="hidden lg:flex items-center gap-8" data-id="element-292">
            {links.map(link => <a key={link.label} href={link.href} target="_top" rel="noopener noreferrer" className="font-poppins text-[14px] font-medium text-plum-light hover:text-plum transition-colors link-underline" data-id="element-293">
                {link.label}
              </a>)}
          </div>

          {/* Desktop Auth Button */}
          <div className="hidden lg:block" data-id="element-294">
            <a href="https://wa.me/40744377234" target="_top" rel="noopener noreferrer" className="inline-flex items-center justify-center py-2.5 px-6 rounded-lg font-poppins font-semibold text-[14px] transition-all duration-200 hover:scale-[1.02] cursor-pointer no-underline bg-orange text-white hover:bg-orange-hover hover:shadow-btn-orange" data-id="element-295">
              Vrei să vorbim?
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button onClick={() => setIsOpen(!isOpen)} className="lg:hidden w-10 h-10 flex items-center justify-center text-plum" aria-label="Toggle menu" data-id="element-296">
            {isOpen ? <X className="w-6 h-6" data-id="element-297" /> : <Menu className="w-6 h-6" data-id="element-298" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && <div className="lg:hidden bg-cream/98 backdrop-blur-md border-t border-plum-border pb-6" data-id="element-299">
            <div className="flex flex-col gap-1 pt-4" data-id="element-300">
              {links.map(link => <a key={link.label} href={link.href} target="_top" rel="noopener noreferrer" onClick={() => setIsOpen(false)} className="font-poppins text-[15px] font-medium text-plum-light hover:text-plum hover:bg-plum/5 px-4 py-3 rounded-lg transition-colors" data-id="element-301">
                  {link.label}
                </a>)}
              <div className="px-4 pt-4" data-id="element-302">
                <a href="https://wa.me/40744377234" target="_top" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full py-2.5 px-6 rounded-lg font-poppins font-semibold text-[14px] transition-all duration-200 hover:scale-[1.02] cursor-pointer no-underline bg-orange text-white hover:bg-orange-hover hover:shadow-btn-orange" data-id="element-303">
                  Vrei să vorbim?
                </a>
              </div>
            </div>
          </div>}
      </div>
    </nav>;
}